import { motion, useScroll, useTransform, useSpring } from 'framer-motion';

/**
 * Subtle, scroll-reactive ambient background.
 * Replaces the old Samoan band — soft neon light pools that drift slowly
 * as the page scrolls, layered over a deep base with film grain.
 */
export default function ScrollAmbient() {
  const { scrollYProgress } = useScroll();
  const p = useSpring(scrollYProgress, { stiffness: 60, damping: 24, mass: 0.5 });

  const y1 = useTransform(p, [0, 1], ['-6%', '-34%']);
  const x1 = useTransform(p, [0, 1], ['0%', '16%']);

  const y2 = useTransform(p, [0, 1], ['10%', '58%']);
  const x2 = useTransform(p, [0, 1], ['0%', '-20%']);

  const y3 = useTransform(p, [0, 1], ['30%', '-12%']);
  const x3 = useTransform(p, [0, 1], ['0%', '10%']);

  return (
    <div
      aria-hidden
      data-testid="scroll-ambient"
      className="fixed inset-0 z-0 overflow-hidden bg-[#050505] pointer-events-none"
    >
      <motion.div
        style={{
          y: y1,
          x: x1,
          background:
            'radial-gradient(circle, rgba(216,255,58,0.16) 0%, rgba(216,255,58,0.05) 35%, transparent 68%)',
          filter: 'blur(40px)',
        }}
        className="absolute -top-[10%] left-[6%] h-[62vh] w-[62vh] rounded-full"
      />
      <motion.div
        style={{
          y: y2,
          x: x2,
          background:
            'radial-gradient(circle, rgba(58,150,255,0.14) 0%, rgba(58,150,255,0.04) 38%, transparent 70%)',
          filter: 'blur(48px)',
        }}
        className="absolute top-[35%] right-[2%] h-[70vh] w-[70vh] rounded-full"
      />
      <motion.div
        style={{
          y: y3,
          x: x3,
          background:
            'radial-gradient(circle, rgba(255,120,80,0.10) 0%, rgba(255,120,80,0.03) 40%, transparent 72%)',
          filter: 'blur(52px)',
        }}
        className="absolute bottom-[4%] left-[28%] h-[56vh] w-[56vh] rounded-full"
      />
      <div className="grain" style={{ opacity: 0.05 }} />
    </div>
  );
}
